import React, { useState } from "react";
import styles from "./galeria_cubonetattoo.module.scss";
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import { Link } from "react-router-dom";
import { FaArrowLeft, FaChevronLeft, FaChevronRight, FaTimes } from "react-icons/fa";
import Galeria1 from './src/galeria/1.png';
import Galeria2 from './src/galeria/2.png';
import Galeria3 from './src/galeria/3.png';
import Galeria4 from './src/galeria/4.png';
import Galeria5 from './src/galeria/5.png';
import Galeria6 from './src/galeria/6.png';
import Galeria7 from './src/galeria/7.png';
import Galeria8 from './src/galeria/8.png';
import Galeria9 from './src/galeria/9.png';
import Galeria10 from './src/galeria/10.png';
const images = [Galeria1, Galeria2, Galeria3, Galeria4, Galeria5, Galeria6, Galeria7, Galeria8, Galeria9, Galeria10];

const Galeria_cubonetattoo: React.FC = () => {
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const openLightbox = (index: number) => {
        setCurrentIndex(index);
        setLightboxOpen(true);
    };

    const closeLightbox = () => setLightboxOpen(false);

    const prevImage = () => setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    const nextImage = () => setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));

    return (
        <div className={styles.galeria_cubonetattoo}>
            {/* HEADER */}
            <div className={styles.header}>
                <Link to="/cubonetattoo" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1 className="mb-0">Galeria</h1>
            </div>

            {/* CONTEÚDO - Galeria */}
            <div className={styles.content}>
                <div className={styles.galleryGrid}>
                    {images.map((img, index) => (
                        <div key={index} className={styles.imageContainer} onClick={() => openLightbox(index)}>
                            <img src={img} alt={`Galeria ${index + 1}`} />
                        </div>
                    ))}
                </div>
            </div>

            {/* Lightbox */}
            {lightboxOpen && (
                <div className={styles.lightbox}>
                    <button className={styles.closeBtn} onClick={closeLightbox}><FaTimes /></button>
                    <button className={styles.prevBtn} onClick={prevImage}><FaChevronLeft /></button>
                    <img src={images[currentIndex]} alt={`Galeria ${currentIndex + 1}`} className={styles.lightboxImage} />
                    <button className={styles.nextBtn} onClick={nextImage}><FaChevronRight /></button>
                </div>
            )}

            {/* FOOTER */}
            <div className={styles.footer}>
                <div className={styles.divSocials}>
                    <a href="https://wa.me/5517997449691?text=Olá, vim pelo link na bio e gostaria de mais informações..." target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><WhatsappIcon height="30" color="#ffffff" /></div>
                            <span>WhatsApp</span>
                        </div>
                    </a>
                    <a href="https://maps.app.goo.gl/NnYiDFBX8zqoTtnR7" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><MapsIcon height="30" color="#ffffff" /></div>
                            <span>Localização</span>
                        </div>
                    </a>
                    <a href="https://www.instagram.com/cubonetattoo?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><InstagramIcon height="26" color="#ffffff" /></div>
                            <span>Instagram</span>
                        </div>
                    </a>
                </div>
                <div className={styles.signature}>
                    Desenvolvido por{" "}
                    <a href="https://www.linksvibe.com.br" target="_blank" rel="noreferrer">
                        Links Vibe
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Galeria_cubonetattoo;
